import React, { PropTypes } from 'react';
import { FontIcon, FlatButton } from 'material-ui';

import CloudSponge from '../invite-contacts/cloudsponge';

const TCContactImport = ({ parentStyle, buttonStyle, afterSubmitContacts, ...other }) => {
  const sources = [
    { value: 'gmail', name: 'Gmail' },
    { value: 'yahoo', name: 'Yahoo' },
    { value: 'windowslive', name: 'Outlook' },
    { value: 'linkedin', name: 'LinkedIn' },
  ].map(({ value, name }, key) => {
    const sourceButton = {};
    switch (value) {
      case 'gmail':
        sourceButton.class = 'google';
        sourceButton.backgroundColor = '#e04c40';
        break;
      case 'yahoo':
        sourceButton.class = 'yahoo';
        sourceButton.backgroundColor = '#400090';
        break;
      case 'windowslive':
        sourceButton.class = 'windows8';
        sourceButton.backgroundColor = '#34b2e4';
        break;
      case 'linkedin':
        sourceButton.class = 'linkedin';
        sourceButton.backgroundColor = '#0077b5';
        break;
      default:
        sourceButton.backgroundColor = 'none';
        break;
    }
    return (
    <FlatButton
      key={key}
      icon={<FontIcon
        className={sourceButton.class ? `tc-icon-${sourceButton.class}` : ''}
        style={{
          fontSize: '18px',
          marginLeft: '12px',
          marginRight: '20%',
        }}
      />}
      style={{
        backgroundColor: sourceButton.backgroundColor,
        color: '#ffffff',
        textAlign: 'left',
        width: '100%',
      }}
      label={name}
    />
    );
  });

  return (
    <CloudSponge
      afterSubmitContacts={afterSubmitContacts}
      browserContactCacheMin={0}
      displaySelectAllNone
      ignoreMultipleEmails
      initiallySelectedContacts
      inlineOauth={false}
      include={['name', 'email']}
      skipSourceMenu
      sources={['gmail', 'yahoo', 'windowslive', 'icloud', 'linkedin']}
      style={Object.assign({}, { textAlign: 'left', listStyle: 'none' }, parentStyle)}
      childStyle={Object.assign({}, { padding: '2px 50px', textAlign: 'center' }, buttonStyle)}
      {...other}
    >
      {sources}
    </CloudSponge>
  );
};

TCContactImport.propTypes = {
  afterSubmitContacts: PropTypes.func.isRequired,
  buttonStyle: PropTypes.object,
  parentStyle: PropTypes.object,
};

export default TCContactImport;



// WEBPACK FOOTER //
// ./src/app/components/invite-contacts/tc-contact-import.jsx